import { useState, useEffect } from 'react';
import { fetchModel } from 'shared/store';

const useFetchModel = (endpoint, modelType, modelClass) => {
  const [model, setModel] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const fetchedModel = await fetchModel(endpoint, modelType);
      setModel(modelClass ? new modelClass(fetchedModel) : fetchedModel);
      setIsLoading(false);
    };
    fetchData();
  }, [endpoint, modelType]);

  return [model, isLoading];
};

export default useFetchModel;
